import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/seller-outbound-return/constants'
import PropTypes from 'prop-types'
import React from 'react'


const propTypes = {
  status: PropTypes.string
}


/**
 * To give nice look on Consignor Return `status`.
 * It maps `status` to certain style and pass to `StatusBadge`.
 * @param {string} status Consignor Return `status`. available values
 * - `pending`
 * - `accepted`
 * - `scheduled`
 * - `seller_received`
 */
const SellerOutboundReturnStatusBadge = ({ status }) => {
  const colorMap = {
    [STATUS.PENDING]         : 'warning',
    [STATUS.ACCEPTED]        : 'primary',
    [STATUS.SCHEDULED]       : 'info',
    [STATUS.SELLER_RECEIVED] : 'success',
    [STATUS.CANCELLED]       : 'danger'
  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

SellerOutboundReturnStatusBadge.propTypes = propTypes

export default SellerOutboundReturnStatusBadge
